<template>
  <div id='home'>
    <TopNav />
    <InfoBox />
    <DriverLookup/>
    <Form />
  </div>
</template>

<script>
import TopNav from '@/components/layout/TopNav';
import Form from '@/components/Form';
import DriverLookup from '@/components/DriverLookup';
import InfoBox from '@/components/layout/InfoBox';

export default {
  name: 'Home',
  components: {
    TopNav,
    Form,
    DriverLookup,
    InfoBox,
  },
};
</script>
